export default __webpack_public_path__ + "static/media/ResultIcon.d9acde49.svg";